import React, { Suspense } from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import LoadingPage from "components/common_components/LoadingPage";

function SecureRoute({ component: Component, render, ...props }) {
    const { loggedIn } = useSelector((state) => state.Login);
    const { allowedPaths } = useSelector((state) => state.Security);
    const { path } = props;

    if (!loggedIn) {
        return <Redirect to="/login" />;
    }

    if (allowedPaths && Array.isArray(allowedPaths) && allowedPaths.length > 0) {
        const allowedPath = allowedPaths.filter((ap) => path.startsWith(ap));
        if (!(allowedPath && allowedPath.length > 0)) {
            return <Redirect to="/unauthorized" />;
        }
    } else {
        return <Redirect to="/unauthorized" />;
    }

    return (
        <Route
            {...props}
            render={(routeProps) => (
                <Suspense fallback={<LoadingPage />}>
                    {Component && <Component {...routeProps} />}
                    {render && render({ ...routeProps })}
                </Suspense>
            )}
        />
    );
}

export default SecureRoute;
